import React from 'react';
import classnames from 'classnames';

const HorizontalLine = props => (
  <div
    className={classnames(props.bg, props.className)}
    style={{ height: props.height }}
  />
);

HorizontalLine.defaultProps = {
  height: 1,
  bg: 'bgNeutral050',
  width: 'format100',
  className: '',
};

export default HorizontalLine;
